/**
 * @desc 导入并且创建报价方案
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  params: API.tms.logisticsQuotation.importAndCreateQuotation.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/tms/logisticsQuotation/import/quotation`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
